<template>
  <div>
    <div id="swagger-ui"></div>
  </div>
</template>

<script>
import { baseUrl } from "@/constants";
import SwaggerUI from "swagger-ui";
import "swagger-ui/dist/swagger-ui.css";
import axios from "axios";

export default {
  data() {
    return {
      pdfCarregado: true
    };
  },
  async mounted() {
    const auth = localStorage.getItem("auth");
    const jwtAuthToken = JSON.parse(auth);

    const spec = await axios.get(baseUrl + "/doc/doc.json", {
      headers: {
        authorization: `Bearer ${jwtAuthToken.token}`,
      },
    });

    SwaggerUI({
      spec: spec.data,
      dom_id: "#swagger-ui",
    });

    const elements = document.getElementsByClassName(
      "information-container wrapper"
    );

    while (elements.length > 0) {
      elements[0].parentNode.removeChild(elements[0]);
    }
  }
};
</script>
